import projectEditComponent from './project-edit.component';

const projectEditModule = angular.module('projectEdit', [
])
  .component('projectEdit', projectEditComponent)
  .name;

export default projectEditModule;
